import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { NavigationEnd, Router } from "@angular/router";

@Injectable({ providedIn: 'root' })
export class ProfileService {
  // private profile: any = null;
   profileSubject = new BehaviorSubject<any>(null);

  setProfile(data: any) {
    this.profileSubject.next(data);
  }

  getProfile() {
    return this.profileSubject.asObservable();
  }

  getProfileValue() {
    return this.profileSubject.value;
  }
}
